import { styled } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

export const ExpireLabel = styled("span")(({ expired }: { expired: boolean }) => ({
  color: expired ? colors.error600 : colors.gray600,
}));

export const ArchiveBadge = styled("div")(() => ({
  columnGap: "8px",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  padding: "10px 12px",
  background: colors.gray100,
  borderRadius: "100px",
  cursor: "pointer",
  "& span": {
    color: colors.gray600,
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: "0.5px",
  },
}));

export const UploadButtonInput = styled("input")(() => ({
  display: "none",
}));

type ClickableRowActionButtonProps = {
  disabled?: boolean;
};

export const ClickableRowActionButton = styled("div")(
  ({ disabled = false }: ClickableRowActionButtonProps) => ({
    cursor: disabled ? "not-allowed" : "pointer",
    marginLeft: "4px",
  })
);

export const ColumnStatus = styled("div")(() => ({
  position: "relative",
  left: "-2px",
  "& > div": {
    width: "fit-content",
  },
}));

export const ContentWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",

  color: colors.gray600,
  fontSamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  paddingRight: "16px",
}));

export const useStyles = makeStyles(() => ({
  column: {
    width: "170px",
  },
}));
